// services/websocket.js
import { io } from "socket.io-client";
import { addEscalationOneIO, addNDROneIO, addOrderIO, addShipmentIO, addWalletTransaction, addWeightDisputeIO, bookOrderIO, createBulkOrderIO, setBalance, updateChannel, updateCourier, updateEscalationOneIO, updateNDROneIO, updateOrderIO, updateShipmentIO, updateWeightDisputeIO, upsertShipmentsIO } from "../app/slices";
import { SocketEvents } from "../constants/SocketEventRegistry";

const baseURL = import.meta.env.VITE_BACKEND_URL || "https://api.indiancouriercompany.com/api";

// Get the backend URL from environment variables or use a default
const BACKEND_URL = "https://api.indiancouriercompany.com";
let socket = null;
// Initialize socket with authentication
export const initializeSocket = (store) => {
  // Get auth token from localStorage
  console.log("initializing socket");

  const token = localStorage.getItem("token");
  // Create socket instance with auth
  socket = io(BACKEND_URL, {
    transports: ["websocket"],
    withCredentials: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    auth: {
      token: `Bearer ${token}`, // Send token in the handshake auth payload
    },
    extraHeaders: {
      "ngrok-skip-browser-warning": "true", // Headers for polling (if needed)
    },
  });

  // Connection events
  socket.on("connect", () => {
    console.log("WebSocket connected");
  });

  socket.onAny((event, ...args) => {
    console.log(`Received socket event: ${event}`, args);
  });

  socket.on("connect_error", (error) => {
    console.error("WebSocket connection error:", error.message);
  });

  socket.on(SocketEvents.WALLET.WALLET_UPDATED, (wallet) => {
    try {
      console.log("Wallet updated:", wallet);
      console.log("Wallet balance:", wallet?.balance);
      console.log("Wallet transaction:", wallet?.transaction);

      // Dispatch actions
      if (wallet?.balance !== undefined && wallet?.balance !== null) {
        store.dispatch(setBalance(wallet.balance));
      }
      if (wallet?.transaction && wallet?.transaction !== null) {
        store.dispatch(addWalletTransaction(wallet.transaction));
      }

      console.log("Wallet state update completed successfully");
    } catch (error) {
      console.error("Error processing wallet update:", error);
    }
  });

  socket.on(SocketEvents.ORDER.CREATED, (order) => {
    console.log("Order created:", order);
    // Dispatch an action to add the new order
    store.dispatch(addOrderIO(order));
  });

  socket.on(SocketEvents.ORDER.UPDATED, (order) => {
    console.log("Order updated:", order);
    // Dispatch an action to update the order
    store.dispatch(updateOrderIO(order));
  });

  socket.on(SocketEvents.ORDER.CANCEL, (order) => {
    console.log("Order cancel:", order);
    // Dispatch an action to remove the order
    store.dispatch(updateOrderIO(order));
  });

  socket.on(SocketEvents.ORDER.BULK_UPDATE, (orders) => {
    console.log("Bulk orders:", orders);
    // Dispatch an action to add the new order
    store.dispatch(createBulkOrderIO(orders.orders));
  });

  socket.on(SocketEvents.SHIPMENT.CREATED, (results) => {
    console.log("Shipment Creation:", results);
    //Order Booing results shipment creation and failed orders
    const shipments = results?.details?.successes?.shipments;
    if (shipments && shipments.length > 0) {
      store.dispatch(upsertShipmentsIO(shipments));
    }
    store.dispatch(bookOrderIO(results));
  });

  socket.on(SocketEvents.SHIPMENT.CANCEL, (results) => {
    console.log("shipment:cancel:", results);
    //Order Booing results shipment creation and failed orders
    store.dispatch(updateShipmentIO(results));
  });

  socket.on(SocketEvents.WEIGHT_DISPUTE.CREATED, (disputes) => {
    console.log("Web Socket= disputes:", disputes);
    //weight dispute created by admin
    store.dispatch(addWeightDisputeIO(disputes));
  });

  socket.on(SocketEvents.WEIGHT_DISPUTE.ACTION_UPDATED, (dispute) => {
    console.log("weightDispute:action:updated:", dispute);
    //weight dispute accepted
  });

  socket.on(SocketEvents.WEIGHT_DISPUTE.RAISE_DISPUTE, (dispute) => {
    console.log("weightDispute:raise:dispute:", dispute);
    //weight dispute raise dispute 
    store.dispatch(updateWeightDisputeIO(dispute));
  })

  socket.on(SocketEvents.ESCALATION.CREATED, (dispute) => {
    console.log("weightDispute:raise:dispute:success:", dispute);
    //weight dispute raise dispute success
    // create escalation
    store.dispatch(addEscalationOneIO(dispute));
  })

  socket.on(SocketEvents.ESCALATION.UPDATED, (dispute) => {
    console.log("weightDispute:raise:dispute:success:", dispute);
    //reply escalation
    //weight dispute raise dispute success
    store.dispatch(updateEscalationOneIO(dispute));
  })

  socket.on(SocketEvents.KYC.UPDATED, async (status) => {
    console.log("KYC updated:", status);
    try {
      const response = await fetch(`${baseURL}/common/refresh-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: localStorage.getItem("refreshToken"),
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to refresh token");
      }

      const data = await response.json();
      if (!data.success) {
        console.error("Error refreshing token:", data.error?.message);
        window.location.href = "/login";
        return;
      }
      console.log("Response Data-->>", data);
      console.log("Token refreshed successfully");
    } catch (error) {
      console.error("API call failed:", error);
      window.location.href = "/login";
    }
  });

  socket.on(SocketEvents.NDR.CREATED, (ndr) => {
    console.log("NDR created:", ndr);
    // Dispatch an action to add the new order
    // ndr created by admin
    store.dispatch(addNDROneIO(ndr));
  });

  socket.on(SocketEvents.NDR.UPDATED, (ndr) => {
    console.log("NDR updated:", ndr);
    // Dispatch an action to add the new order 
    // ndr updated by customer
    store.dispatch(updateNDROneIO(ndr));
  });

  socket.on(SocketEvents.COURIER.UPDATED, (courier) => {
    console.log("courier:updated", courier);
    // Dispatch an action to add the new order
    // courier:updated by admin
    store.dispatch(updateCourier(courier));
  });

  socket.on(SocketEvents.CHANNEL.UPDATED, (channel) => {
    console.log("channel:updated", channel);
    // Dispatch an action to add the new order
    // channel update by admin
    store.dispatch(updateChannel(channel));
  });

  socket.on(SocketEvents.USER_CHANNEL.CREATED, (createdChannel) => {
    console.log("channel:created", createdChannel);
    // Dispatch an action to add the new order
    // channel created by customer
  });

  socket.on(SocketEvents.USER_CHANNEL.DELETED, (deletedChannel) => {
    console.log("channel:deleted", deletedChannel);
    // channel deleted by customer
  });

  socket.on(SocketEvents.USER_COURIER.UPDATED, (createdChannel) => {
    console.log("userCourier:updated", createdChannel);
    // courier update by customer
    // channel created by customer
  });

  socket.on(SocketEvents.NOTIFICATION.BROADCAST, (notification) => {
    console.log("notification:broadcast", notification);
    // Dispatch an action to add the new order
    // notification:broadcast by admin
  })

  socket.on(SocketEvents.NOTIFICATION.CREATED, (notification) => {
    console.log("notification:created", notification);
    // Dispatch an action to add the new order
    // notification:created for customer
  })

  // Handle announcements
  socket.on("announcement", (data) => {
    console.log("Announcement:", data.message);
    // You could dispatch to a notifications reducer here
  });

  // Handle errors
  socket.on("error", (error) => {
    console.error("WebSocket error:", error.message);
  });

  return socket;
};

// Bulk action dispatch function
export const performBulkAction =
  (actionType, selectedIds) => (dispatch, getState) => {
    if (!socket || !socket.connected) {
      console.error("Socket not connected. Cannot perform bulk action.");
      return;
    }

    socket.emit(actionType, selectedIds);
    dispatch({ type: "orders/clearSelectedOrders" }); // Assuming this action exists
  };

// Join a specific room
export const joinRoom = (roomName) => {
  if (!socket || !socket.connected) {
    console.error("Socket not connected. Cannot join room.");
    return;
  }

  socket.emit("join-room", roomName);
};

// Leave a specific room
export const leaveRoom = (roomName) => {
  if (!socket || !socket.connected) {
    console.error("Socket not connected. Cannot leave room.");
    return;
  }

  socket.emit("leave-room", roomName);
};

// Send a message
export const sendMessage = (data) => {
  if (!socket || !socket.connected) {
    console.error("Socket not connected. Cannot send message.");
    return;
  }

  socket.emit("send-message", data);
};

// Disconnect socket
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("WebSocket disconnected");
  }
};

// Export the socket instance
export const getSocket = () => socket;

// Export all functions
export default {
  initializeSocket,
  performBulkAction,
  joinRoom,
  leaveRoom,
  sendMessage,
  disconnectSocket,
  getSocket
};
